'use client';

import Script from 'next/script';
import { CLARITY_PROJECT_ID } from '@/utils/clarity';

/**
 * Microsoft Clarity Component
 * Session recording & heatmaps, loaded with lazyOnload for zero performance impact
 *
 * Respects user privacy (checks for project ID) - no-ops until
 * NEXT_PUBLIC_CLARITY_PROJECT_ID is configured
 */
export default function MicrosoftClarity() {
  if (!CLARITY_PROJECT_ID) {
    return null;
  }

  return (
    <Script
      id="microsoft-clarity"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
          (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");
        `,
      }}
    />
  );
}
